module.exports = __webpack_public_path__ + "img/jcc-logo.075244f0.jpg";